import { Navigate } from "react-router-dom"
import { useSupabaseSession } from "../../utils/AuthSessionProvider"

const ProtectedRoute = ({ children }) => {
  const { session } = useSupabaseSession()
  if (session === undefined) return null // ローディング中
  return session ? children : <Navigate to="/unauthorized" replace />
}

export default ProtectedRoute
